export const APP_NAME = "DOMINO";
